import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Layout.module.css';
import { useSession, supabase } from '../auth/supabase';
import NewPatientWizard from './NewPatientWizard';

export default function Layout({ children }) {
  const session = useSession();
  const location = useLocation();
  const [showWizard, setShowWizard] = useState(false);
  const active = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div className={styles.root}>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>Case Presenter</div>
        <div className={styles.subtle}>Minimal case workflow</div>
        <button className={styles.addBtn} onClick={() => setShowWizard(true)}>Add Patient</button>
        <nav className={styles.nav}>
          <Link className={active('/dashboard') ? styles.navItemActive : styles.navItem} to="/dashboard">Dashboard</Link>
          <Link className={active('/patients') ? styles.navItemActive : styles.navItem} to="/patients">Patients</Link>
          <Link className={active('/templates') ? styles.navItemActive : styles.navItem} to="/templates">Templates</Link>
        </nav>
      </aside>
      <main className={styles.main}>
        <div className={styles.topbar}>
          {session && <div className={styles.signed}>SIGNED IN AS <b>{session.user?.email}</b></div>}
          <button className={styles.signout} onClick={() => supabase.auth.signOut()}>Sign out</button>
        </div>
        <div className={styles.content}>{children}</div>
      </main>
      {showWizard && <NewPatientWizard onClose={() => setShowWizard(false)} />}
    </div>
  );
}
